import { Permission } from './permission';

export class ConfiguredPermission {
  constructor(
    public permission: Permission,
    public propagatePermission: boolean,
    public subPermissions: { [key: string]: ConfiguredPermission } // Dictionary<Guid, ConfiguredPermission>
  ) {}
}
